import React, {useEffect, useRef, useState} from 'react';
import * as $ from 'jquery';

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import MemberModal from "./MemberModal";

import PerfectScrollbar from "perfect-scrollbar";
import axiosInstant from "../libs/axiosInstant";
import {useForm} from "react-hook-form";

import {useSelector} from "react-redux";
import numeral from "numeral";
import Toast from "../libs/Toast";

function ComposeMessage() {

    const { config: {option, composeMenu, compose} } = useSelector((state) => state.mailBox)

    const {register, handleSubmit, reset, formState: {errors},} = useForm();

    const [recipient, setRecipient] = useState('');
    const [message, setMessage] = useState('');

    const handleEditorChange = (value) => {
        setMessage(value);
    };

    useEffect(() => {
        $('.menu-compose').on('click', function (e) {
            e.preventDefault();
            //$('.compose, .menu-compose').toggleClass('d-none');
            $('.compose').removeClass('d-none');
            $('.menu-compose').addClass('d-none');
        });

        $('.compose-title, .nav-link-minimize').on('click', function (e) {
            $(this).closest('.compose').toggleClass('minimize');
        });

        $('.nav-link-fullscreen').on('click', function (e) {
            e.preventDefault();
            $(this).closest('.compose').toggleClass('fullscreen');
        });

        $('.nav-link-close').on('click', function (e) {
            e.preventDefault();
            $(this).closest('.compose').addClass('d-none').removeClass('minimize fullscreen');
            $('.menu-compose').removeClass('d-none');
        });

        // Cleanup function to remove the event handler when component unmounts
        return () => {
            $('.menu-compose').off('click');
            $('.compose-title, .nav-link-minimize').off('click');
            $('.nav-link-fullscreen').off('click');
            $('.nav-link-close').off('click');
        };
    }, [])

    const recipientRef = useRef(null);
    useEffect(() => {
        const ms = new PerfectScrollbar(recipientRef.current);
        return () => ms.destroy()
    }, [recipient])

    const onSubmit = async (data) => {

        const formData = new FormData();
        formData.append('recipient', recipient.map((r) => r.id));
        formData.append('message', message);
        formData.append('subject', data.subject);

        Array.from(data.attachments).forEach((file) => {
            formData.append('attachments[]', file);
        });

        try {
            const { data } = await axiosInstant.post('/inbox/send', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            console.log(data, 'data', (data.status ? 'success' : 'error'))
            Toast((data.status ? 'success' : 'error'), data.message)
            if(data.status) {
                setRecipient('')
                setMessage('')
                reset()
                $('.nav-link-close').closest('.compose').addClass('d-none').removeClass('minimize fullscreen');
                $('.menu-compose').removeClass('d-none');
            }
            /*console.log('response', data);*/
        } catch (error) {
            console.error("There was an error sending the message!", error);
            Toast('error', error);
        }
    }


    return (
        <>
            <MemberModal setRecipient={setRecipient}/>
            <a className="menu-compose" style={{ backgroundColor: composeMenu.bgColor, color: composeMenu.color}}>
                <i className="ri-pencil-line"/>
            </a>
            <div className="compose d-none">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="compose-content">
                        <div className="compose-header" style={{ backgroundColor: compose.bgColor, color: compose.color}}>
                            <h6 className="compose-title">New Message</h6>
                            <nav className="nav">
                                <a href="#" className="nav-link nav-link-minimize">
                                    <i className="ri-subtract-line"/>
                                </a>
                                <a href="#" className="nav-link nav-link-fullscreen">
                                    <i className="ri-fullscreen-line"/>
                                    <i className="ri-fullscreen-exit-line"/>
                                </a>
                                <a href="#" className="nav-link nav-link-close">
                                    <i className="ri-close-line"/>
                                </a>
                            </nav>
                        </div>
                        <div className="compose-body">
                            <div className="form-group">
                                <div className="d-flex justify-content-between align-items-center">
                                    <small>Select {recipient.length > 0 &&
                                        <b>{numeral(recipient.length).format('0,0')}</b>} recipient's</small>
                                    <div className="symbol-group symbol-hover d-inline">
                                        <div className="symbol symbol-30 symbol-circle symbol-primary"
                                             data-toggle="tooltip" title="Add Recipient's">
                                        <span className="symbol-label font-weight-bold" data-bs-toggle="modal"
                                              style={{backgroundColor: compose.bgButton, borderColor: compose.bgButton, color: compose.colorButton}}
                                              data-bs-target="#memberModal">
                                            <i className="ri-add-fill"></i>
                                        </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="recipient-container" ref={recipientRef}>
                                    <div className="symbol-group symbol-hover">
                                        {recipient && recipient.map((row, i) => {
                                            return <div key={i} className="symbol symbol-30 symbol-circle"
                                                        data-toggle="tooltip" title={row.display_name}>
                                                {(row.avatar ?
                                                        <img src={row.avatar} alt="avatar"/> :
                                                        <span className="symbol-label font-weight-bold" style={{
                                                            backgroundColor: row.color.backgroundColor,
                                                            color: row.color.color
                                                        }}>{row.first_letter}</span>
                                                )}
                                            </div>
                                        })}
                                        {/*<div className="symbol symbol-30  symbol-circle symbol-light" data-toggle="tooltip" title="" data-original-title="More users">
                                            <span className="symbol-label font-weight-bold">5+</span>
                                        </div>*/}
                                    </div>
                                </div>
                                {/*<input type="text" className="form-control" placeholder="Enter receipient's email address"/>*/}
                            </div>

                            <div className="form-group border-top pt-3 mt-0">
                                <input type="text" className="form-control"
                                       placeholder="Enter subject" {...register('subject', {required: true})}/>
                            </div>
                            <div className="form-group editor-container">
                                <ReactQuill
                                    value={message}
                                    onChange={handleEditorChange}
                                    theme="snow"
                                    placeholder="Type something..."
                                />
                                {/*<div dangerouslySetInnerHTML={{__html: message}}/>*/}
                                {/*<textarea className="form-control" id="compose-editor" rows={10} defaultValue={""}/>*/}
                            </div>
                            {option?.message_center?.delete_duration_msg &&
                            <div className="alert alert-warning d-flex align-items-center tab-description m-0 mt-2" role="alert">
                                <i className="ri-error-warning-line ri-2x"></i>
                                <div dangerouslySetInnerHTML={{__html: option.message_center.delete_duration_msg}}/>
                            </div>
                            }
                        </div>
                        <div className="compose-footer">
                            <button type="submit" className="btn btn-primary btn-icontext" style={{backgroundColor: compose.bgButton,borderColor: compose.bgButton, color: compose.colorButton}}>
                            <i className="ri-send-plane-fill me-2"/> Send
                            </button>
                            <label className="btn btn-white btn-icon btn-attach">
                                <i className="ri-attachment-2"/>
                                <input type="file" accept={option.allowed_extensions} {...register('attachments')} multiple/>
                            </label>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}

export default ComposeMessage;
